module.exports = __webpack_public_path__ + "img/avatar5.3f732159.png";